import * as React from "react";
import { FormGroup } from "../RightAsideHelpers";
import { WorkflowNode } from "../../types";
import Select from "@/components/Select";
import useChatWindows from "@/hooks/useChatWindows";

interface Props {
  node: WorkflowNode;
  onUpdate: (node: Partial<WorkflowNode>) => void;
}

/**
 * SelectChatWindowEditor — picks which Chat Window design to serve when the
 * widget_loaded workflow matches. Written as `node.chatWindowId` so the
 * WidgetRuntimeController can return it to the loader.
 */
export default function SelectChatWindowEditor({ node, onUpdate }: Props) {
  const { chatWindows, loading } = useChatWindows();

  const options: Record<string, string> = React.useMemo(() => {
    const map: Record<string, string> = { "": loading ? "Loading…" : "— Select a chat window —" };
    (chatWindows || []).forEach((cw) => {
      map[String(cw.id)] = cw.name || `Chat window #${cw.id}`;
    });
    return map;
  }, [chatWindows, loading]);

  return (
    <FormGroup
      label="Chat Window"
      tooltipText="When this workflow matches on page load, serve this chat window design to the visitor."
    >
      <Select
        options={options}
        value={node.chatWindowId ? String(node.chatWindowId) : ""}
        onChange={(v) => {
          const id = v ? parseInt(v, 10) : undefined;
          onUpdate({ chatWindowId: Number.isFinite(id) ? id : undefined });
        }}
      />
    </FormGroup>
  );
}
